import { render } from "./Reservas.vue?vue&type=template&id=a5248c2c&scoped=true"
import script from "./Reservas.vue?vue&type=script&lang=js"
export * from "./Reservas.vue?vue&type=script&lang=js"

import "./Reservas.vue?vue&type=style&index=0&id=a5248c2c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5248c2c"]])

export default __exports__